import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ 
  providedIn: 'root' 
})
export class SearchService {
  private readonly searchTermSource = new BehaviorSubject<string | null>(null);
  searchTerm$ = this.searchTermSource.asObservable();

  sendSearchTerm(term: string) {
    this.searchTermSource.next(term);
  }

  private readonly classificacoesSource = new BehaviorSubject<number[]>([]);
  classificacoes$ = this.classificacoesSource.asObservable();

  atualizarClassificacoes(classificacoes: number[]) {
    this.classificacoesSource.next(classificacoes);
  }

  private readonly planoSelecionadoSource = new BehaviorSubject<string>('');
  planoSelecionado$ = this.planoSelecionadoSource.asObservable();
   
  selecionarPlano(plano: string) {
    this.planoSelecionadoSource.next(plano);
  }

  private readonly criteriosFiltradosSource = new BehaviorSubject<{dimensao: string, criterios: number[]}[]>([]);
  criteriosFiltrados$ = this.criteriosFiltradosSource.asObservable();

  atualizarCriteriosFiltrados(dados: {dimensao: string, criterios: number[]}[]) {
    this.criteriosFiltradosSource.next(dados);
  }

  // Novos filtros para perguntasFiltradas
  private readonly criterioSelecionadoSource = new BehaviorSubject<number | null>(null);
  criterioSelecionado$ = this.criterioSelecionadoSource.asObservable();

  atualizarCriterioSelecionado(codCriterio: number | null) {
    this.criterioSelecionadoSource.next(codCriterio);
  }

  private readonly statusCriticoSource = new BehaviorSubject<boolean | null>(null);
  statusCritico$ = this.statusCriticoSource.asObservable();

  atualizarStatusCritico(statusCritico: boolean | null) {
    this.statusCriticoSource.next(statusCritico);
  }

  // Método para aplicar todos os filtros de uma vez
  atualizarFiltros(filtros: { codCriterio?: number | null, bitStatusCritico?: boolean | null, classificacoes?: number[] }) {
    if (filtros.codCriterio !== undefined) {
      this.atualizarCriterioSelecionado(filtros.codCriterio);
    }
    if (filtros.bitStatusCritico !== undefined) {
      this.atualizarStatusCritico(filtros.bitStatusCritico);
    }
    if (filtros.classificacoes !== undefined) {
      this.atualizarClassificacoes(filtros.classificacoes);
    }
  }

  
}